<template>
  <q-dialog :visible="isVisible" title="查看调整记录" width="70%" :innerScroll="false" :showFooter="false" @close="onCancel">
    <div class="product-detail-content">
      <div class="product-info">
        <el-form size="mini">
          <el-row :gutter="40">
            <el-col :span="12">
              <el-form-item label="商品编码">
                <span>{{ rowData.goodsCode }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="商品名称">
                <span>{{ rowData.goodsName }}</span>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="table-container">
        <el-table stripe border :header-cell-style="{ backgroundColor: '#F4F8FB' }" :data="tableData" height="300" v-loading="loading">
          <el-table-column prop="settlementPrice" label="基础价" width="140" align="center"></el-table-column>
          <el-table-column prop="reason" label="调整原因" min-width="200" show-overflow-tooltip></el-table-column>
          <el-table-column prop="updatedBy" label="更新人" width="140" align="center"></el-table-column>
          <el-table-column prop="updatedDate" label="更新时间" width="160" align="center"></el-table-column>
        </el-table>
      </div>
    </div>
    <div class="footer-buttons">
      <el-button @click="onCancel">关闭</el-button>
    </div>
  </q-dialog>
</template>

<script>
export default {
  name: 'ProductDetailDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    rowData: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    isVisible: {
      get() {
        return this.visible;
      },
      set(val) {
        this.$emit('update:visible', val);
      },
    },
  },
  data() {
    return {
      loading: false,
      tableData: [],
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    onCancel() {
      this.isVisible = false;
    },

    init() {
      this.loading = true;
      let data = {
        goodsCode: this.rowData.goodsCode,
      };

      this.$q.goods
        .goodsSettlementPriceAdjustLog({ data: data })
        .then(res => {
          if (res.code == 200) {
            this.tableData = res.data;
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="stylus" scoped>
.product-detail-content {
  .product-info {
    border-radius: 4px;

    span {
      color: #666;
      font-size: 14px;
    }
  }

  .table-container {
    margin-bottom: 20px;
  }
}

.footer-buttons {
  text-align: center;
  padding: 15px 0;
  margin-top: 15px;
}
</style>
